import { gql } from '@apollo/client';

export const DASHBOARD_REGISTRATION_COMPLIANCE = gql`
  query RegistrationCompliance($input: DashboardFilterArgs) {
    ratioRegistrationCompliance(input: $input)
    ratioRegistrationComplianceChange(input: $input)
  }
`;
